import React from 'react';
import styles from './SearchField.module.scss';
import { Button, Form, Icon, Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { selectSearchValueShutdownsFilter } from '../../model/selectors';
import { isInteger } from '../../../../shared/lib/filterValidators';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';
import { setShutdownFilterSearchValue } from '../../model/actions';

const { Search } = Input;
const { Item: FormItem } = Form;

const SearchField = () => {
  const dispatch = useDispatch();

  const searchValue = useSelector(selectSearchValueShutdownsFilter);

  const hasError = Boolean(searchValue?.trim()) && !isInteger(searchValue);

  const handleChange = (val) => {
    const trimValue = val?.trim();

    dispatch(setShutdownFilterSearchValue(trimValue));
  };

  const handleSearch = () => {
    dispatch(fetchShutdownsThunk());
  };

  return (
    <FormItem
      className={styles.root}
      help={hasError ? 'Некорректный номер' : ''}
      validateStatus={hasError ? 'error' : 'validating'}
    >
      <Search
        placeholder="Найти отключение по номеру"
        value={searchValue || ''}
        onChange={(e) => handleChange(e.target.value)}
        onSearch={handleSearch}
        enterButton={
          <Button
            className={styles.enterBtn}
            type="primary"
            disabled={hasError}
          >
            <Icon type="search" />
          </Button>
        }
      />
    </FormItem>
  );
};

export default SearchField;
